import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Sketch from '../views/Sketch.vue'
import SketchGuangDong from '../views/Sketch_guangdong.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'sketch',
    component: Sketch,
    meta: {
      title: '咪咕悦看超级会员'
    }
  },
  {
    path: '/SketchGuangDong',
    name: 'SketchGuangDong',
    component: SketchGuangDong,
    meta: {
      title: '咪咕悦看超级会员'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 尝试从路由元信息中获取标题
  const title = to.meta.title
  if (title) {
    document.title = `${title}`
  } else {
    document.title = `${title}`
  }

  next()
})

export default router
